import React from "react";
import { Box, Typography } from "@mui/material";
import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined";
import ModalShell from "./ModalShell";
import { Collection } from "../../../api/derin";
import { collectionColors, font, subtitleSx } from "./tokens";

interface RemoveAboutDialogProps {
  open: boolean;
  collection: Collection | null;
  onClose: () => void;
  onConfirm: () => void;
  isSubmitting?: boolean;
}

/**
 * Removing the About the Study file is destructive in a way replacing it is not: the
 * client's About tab disappears entirely rather than showing something else, and the
 * stored YAML is the researcher's own file, not something the API can rebuild.
 */
const RemoveAboutDialog: React.FC<RemoveAboutDialogProps> = ({
  open,
  collection,
  onClose,
  onConfirm,
  isSubmitting = false,
}) => (
  <ModalShell
    open={open}
    onClose={onClose}
    title="Remove About the Study"
    subtitle={
      collection
        ? `"${collection.name}" loses its study overview and the About the Study tab stops appearing for the client. Putting it back means uploading the file again.`
        : undefined
    }
    confirmLabel="Remove file"
    onConfirm={onConfirm}
    isSubmitting={isSubmitting}
    danger
  >
    {collection?.aboutFileName && (
      <Box
        sx={{
          display: "flex",
          gap: "10px",
          padding: "12px",
          background: collectionColors.dangerSurface,
          borderRadius: "8px",
        }}
      >
        <WarningAmberOutlinedIcon
          sx={{ width: 18, height: 18, color: collectionColors.danger, flexShrink: 0 }}
        />
        <Box sx={{ minWidth: 0 }}>
          <Typography
            sx={{
              fontFamily: font,
              fontWeight: 500,
              fontSize: "14px",
              lineHeight: "20px",
              color: collectionColors.danger,
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {collection.aboutFileName}
          </Typography>
          <Typography sx={{ ...subtitleSx, fontSize: "13px", lineHeight: "18px" }}>
            This file is deleted, not archived.
          </Typography>
        </Box>
      </Box>
    )}
  </ModalShell>
);

export default RemoveAboutDialog;
